import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ text, to }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(to)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 0',
        marginBottom: '16px',
        cursor: 'pointer',
        color: 'var(--text-medium)',
        fontSize: '14px',
        fontWeight: '500',
        width: 'fit-content'
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M15.75 19.5L8.25 12L15.75 4.5" stroke="var(--text-medium)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      {text}
    </div>
  );
};

export default BackButton;